import './style.css'
export default function Loading() {
  return (
    <div class="loader"/>
  )
}